(function (root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};

    // see QuestionFormConstants
    const ruleConstants = Object.freeze({
        RULE_OPERATOR_EQUALS: 0,
        RULE_OPERATOR_NOTEQUALS: 1,
        RULE_OPERATOR_INCLUDES: 2,
        RULE_OPERATOR_INCLUDES_ALL: 3,
        RULE_ACTION_SHOW: 0,
        RULE_ACTION_HIDE: 1,
        RULE_ACTION_NONE: -1,
    });

    /**
     * Field Rules
     * @deprecated prefer usage in js/public/QuestionForm.js for import
     */
    class FormFieldRule {
        /**
         * @prop {Number} field1 Field which can trigger changes
         * @prop {Number} operator Constant for = !=
         * @prop {Array<Number>} value Field 1's value that triggers change
         * @prop {Number} field2 Field that is effected
         * @prop {Number} action Constant for show/hide
         */
        constructor({
            field1 = 0,
            operator = ruleConstants.RULE_OPERATOR_EQUALS,
            value = [],
            field2 = 0,
            action = ruleConstants.RULE_ACTION_SHOW,
        }) {
            this.field1 = field1;
            this.operator = operator;
            this.value = Array.isArray(value) ? value : [];
            this.field2 = field2;
            this.action = action;
        }

        get oppositeAction() {
            return this.action === ruleConstants.RULE_ACTION_SHOW
                ? ruleConstants.RULE_ACTION_HIDE
                : ruleConstants.RULE_ACTION_SHOW;
        }

        /**
         * Based on value of field do we hide/show/nothing.
         * @param {Number|Array<Number>} field2value Current field value.
         * @returns {Number}
         */
        getFieldAction(field2value) {
            // if field is reset to no answer then hide
            if (field2value === 0 || field2value.length === 0) {
                return ruleConstants.RULE_ACTION_HIDE;
            }
            switch (this.operator) {
                case ruleConstants.RULE_OPERATOR_EQUALS:
                    return this.value.includes(field2value)
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_NOTEQUALS:
                    return !this.value.includes(field2value)
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_INCLUDES:
                    if (!Array.isArray(field2value)) {
                        field2value = [field2value];
                    }
                    // At least one must match
                    return field2value.filter((el) => {
                        return this.value.includes(el);
                    }).length > 0
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_INCLUDES_ALL:
                    if (!Array.isArray(field2value)) {
                        return ruleConstants.RULE_ACTION_NONE;
                    }
                    // All must match
                    return field2value.filter((el) => {
                        return this.value.includes(el);
                    }).length === this.value.length
                        ? this.action
                        : this.oppositeAction;
            }
            return ruleConstants.RULE_ACTION_NONE;
        }
    }

    root.springSpace.la.FormFieldRule = FormFieldRule;
})(window);
